module.exports = __webpack_public_path__ + "static/Abstract - 26011-38e4bb76edd56d8ebb1a20b24c7dce5e.mp4";